var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9485 9.54601C11.7759 9.71335 11.6965 9.95535 11.7359 10.1927L12.3285 13.4727C12.3785 13.7507 12.2612 14.032 12.0285 14.1927C11.8005 14.3593 11.4972 14.3793 11.2485 14.246L8.29585 12.706C8.19319 12.6513 8.07919 12.622 7.96252 12.6187H7.78185C7.71919 12.628 7.65786 12.648 7.60186 12.6787L4.64852 14.226C4.50252 14.2993 4.33719 14.3253 4.17519 14.2993C3.78052 14.2247 3.51719 13.8487 3.58185 13.452L4.17519 10.172C4.21452 9.93268 4.13519 9.68935 3.96252 9.51935L1.55519 7.18602C1.35385 6.99068 1.28385 6.69735 1.37585 6.43268C1.46519 6.16868 1.69319 5.97602 1.96852 5.93268L5.28185 5.45202C5.53385 5.42602 5.75519 5.27268 5.86852 5.04602L7.32852 2.05268C7.36319 1.98602 7.40786 1.92468 7.46185 1.87268L7.52185 1.82602C7.55319 1.79135 7.58919 1.76268 7.62919 1.73935L7.70185 1.71268L7.81519 1.66602H8.09585C8.34652 1.69202 8.56719 1.84202 8.68252 2.06602L10.1619 5.04602C10.2685 5.26402 10.4759 5.41535 10.7152 5.45202L14.0285 5.93268C14.3085 5.97268 14.5425 6.16602 14.6352 6.43268C14.7225 6.70002 14.6472 6.99335 14.4419 7.18602L11.9485 9.54601Z",
    fill: "#FFBC1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.708bffed853e166df5e7b9118a3d7f10.svg";
export { ForwardRef as ReactComponent };